import Container from "../Container";
import Heading from "../Heading";
import React from "react";
import SponsorsImage from "../../statics/img/sponsors.png";

const Collaborators = () => {
  return (
    <Container>
      <div className="mt-4 space-y-4">
        <Heading title="Collaborators" subtitle="Sponsors" />
        <img src={SponsorsImage} alt="Our Sponsors" />
      </div>
    </Container>
  );
};

export default Collaborators;
